// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2rA4i","overflowing":"ReadFullNote_overflowing__28oLw"};